const STATUS_VARIANTS = Object.freeze({
  paid: 'success',
  unpaid: 'danger',
  overdue: 'danger',
  pending: 'warning',
  expiring: 'warning',
  active: 'success',
  cancelled: 'danger',
});

export const normalizeStatus = status =>
  String(status || '')
    .trim()
    .toLowerCase();

export const getStatusBadgeVariant = status => STATUS_VARIANTS[normalizeStatus(status)] || 'default';

export default getStatusBadgeVariant;
